import classnames from 'classnames';
import { RestrictionLevel } from './constants';

import styles from './MembershipTypeLogos.module.scss';
import { Mastercard, OneClubIconLightBlue, StandardIcon } from '../../icons';

type MembershipTypeLogoProps = {
  restrictionLevel: keyof typeof RestrictionLevel;
  className?: string;
};

export const MembershipTypesLogos = ({
  restrictionLevel,
  className,
}: MembershipTypeLogoProps) => {
  if (restrictionLevel === 'none') {
    return null;
  }

  if (
    restrictionLevel === RestrictionLevel.oneClub ||
    RestrictionLevel[restrictionLevel ?? 'none'] === RestrictionLevel.oneClub
  ) {
    return (
      <div className={classnames(styles['icon-group'], className)}>
        <OneClubIconLightBlue
          className={styles['icon-group__item']}
          width={37}
          height={40}
        />
      </div>
    );
  }

  if (
    restrictionLevel === RestrictionLevel.oneClubAdvantage ||
    RestrictionLevel[restrictionLevel ?? 'none'] ===
      RestrictionLevel.oneClubAdvantage
  ) {
    return (
      <div className={classnames(styles['icon-group'], className)}>
        <div className={classnames(styles['icon-group__item'], className)}>
          <StandardIcon
            width={37}
            height={40}
            className={styles['icon-group__item']}
          />
        </div>

        <div className={classnames(styles['icon-group__item'], className)}>
          <Mastercard
            width={40}
            height={40}
            className={styles['icon-group__item']}
          />
        </div>
      </div>
    );
  }
};

export default MembershipTypesLogos;
